<div class="info-group">
  <info-header
    [data]="data"
    [expanded]="expanded"
    [type]="type"
    (toggled)="changeOpenState($event)"
  ></info-header>
  <info-table
    [projectId]="data.projectId"
    [data]="data.sites"
    [tableA]="tableA"
    [showTableA]="showTableA"
    [type]="type"
    [expanded]="expanded"
    [index]="index"
    (handleSitesUpdate)="handleSitesUpdate($event)"
  ></info-table>
</div>
